<template>
  <button
    :type="btnType"
    class="btn"
    :class="[btnOutline ? 'btn-' + 'outline-' + btnClass : 'btn-' + btnClass, btnBlock ? 'btn-block' : '', btnSize, spinner ? 'disabled' : null]"
    :disabled="btnDisabled"
    :style="{ position: spinner ? 'relative' : null }"
    :data-target="dataTarget"
    :data-toggle="dataToggle"
  >
    <span v-if="spinner" class="spinner-border spinner-border-sm btnCustomSpinner" role="status" aria-hidden="true" />

    {{ btnText }}
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    btnText: {
      type: String,
      default: "",
    },
    btnClass: {
      type: String,
      default: "primary",
    },
    btnOutline: {
      type: Boolean,
      default: false,
    },
    btnDisabled: {
      type: Boolean,
      default: false,
    },
    btnBlock: {
      type: Boolean,
      default: false,
    },
    btnSize: {
      type: String,
      default: "",
    },
    btnType: {
      type: String,
      default: "button",
    },
    spinner: {
      type: Boolean,
      default: false,
    },
    dataToggle: {
      type: String,
      default: null,
    },
    dataTarget: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped></style>
